var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorizontalDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 41,
    viewBox: "0 0 105 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.1978,
    cy: 20.5,
    r: 20.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9917,
    cy: 20.5,
    r: 20.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.3311,
    cy: 20.5,
    r: 20.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.1973,
    cy: 20.5,
    r: 20.5,
    fill: "#2C598B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9917,
    cy: 20.5,
    r: 20.5,
    fill: "#4EA1DA"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.3311,
    cy: 20.5,
    r: 20.5,
    fill: "#54B8AA",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4917 20.865H41.3629C41.4312 20.865 41.4935 20.9036 41.524 20.9647L45.2575 28.4572C45.3312 28.605 45.5483 28.5838 45.5921 28.4246L50.5824 10.2727C50.6299 10.0999 50.8734 10.0953 50.9275 10.2662L55.4182 24.4712C55.4675 24.6274 55.6829 24.6418 55.7526 24.4935L59.7611 15.9561C59.8287 15.8121 60.0362 15.8203 60.0923 15.9691L62.1087 21.3209C62.1351 21.391 62.2022 21.4374 62.277 21.4374H72.4917",
    stroke: "white",
    strokeWidth: 1.52932
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalDots);
export default __webpack_public_path__ + "static/media/horizontal-dots.1ef315a69440cac3354cffd62233085b.svg";
export { ForwardRef as ReactComponent };